import translations from '../../../../translations';
import type { NavigationElement } from '../utils';

interface Props {
    navigationElement: NavigationElement;
    setNavigationElement: (navigationElement: NavigationElement) => void;
}

const ConfigureTranslations = ({ navigationElement, setNavigationElement }: Props) => {
    return (
        <div className="translations-wrapper">
            <h3>{translations.TRANSLATIONS_main_header}</h3>
            <label htmlFor="input-translations-checkbox">
                {translations.TRANSLATIONS_show_translations_select_on_nav}
                <input
                    id="input-translations-checkbox"
                    className="translations-checkbox"
                    type="checkbox"
                    checked={navigationElement.showTranslations}
                    onChange={(e) =>
                        setNavigationElement({
                            ...navigationElement,
                            showTranslations: e.target.checked,
                        })
                    }
                />
            </label>
            <span className="help-block">
                {translations.TRANSLATIONS_show_translations_select_on_nav_help_text}
            </span>
        </div>
    );
};

export default ConfigureTranslations;
